import styled from 'styled-components';

export const Container = styled.div`
  form {
    width: 100%;

    label[for='quantity'] {
      font-weight: bold;
      color: var(--text);
      margin-top: 10px;
    }

    input {
      height: 44px;
    }

    .textContainer {
      font-family: 'OpenSans', -apple-system, Helvetica, Arial, sans-serif;
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
      color: #2a2a2a;
      word-wrap: break-word;
      word-break: break-word;
    }

    .buttonsContainer {
      display: flex;
      justify-content: flex-end;
    }
  }
  .modal-body {
    overflow: auto;
  }
  .tableContainer {
    div {
      overflow: hidden;
    }
  }
`;
